import { useRef, useState } from "react";
import ButtonMedia from "@components/ui/button-media";

export interface VideoProps {
  src: string;
}

const Video = ({ src }: VideoProps) => {
  const ref = useRef<HTMLVideoElement | undefined>();
  const [playing, setPlaying] = useState<boolean>(false);

  const handleClick = () => {
    if (!ref.current) return;
    ref.current.play();
    ref.current.controls = true;
    setPlaying(true);
  };

  return (
    <>
      {!playing && <ButtonMedia text="Play" onClick={handleClick} />}
      <video ref={ref} src={src} />
    </>
  );
};

export default Video;
